import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

const PhoneIcon = ({ phone }) => {
  let title, iconClass;

  if (!phone) {
    title = "TELEFONO NON PRESENTE";
    iconClass = "icon-danger";
  } else if (/^\+?\d{6,15}$/.test(phone)) { // Controllo base per numeri di telefono
    title = `TELEFONO VALIDO: ${phone}`;
    iconClass = "icon-success";
  } else {
    title = "TELEFONO NON VALIDO";
    iconClass = "icon-danger";
  }

  return (
    <span title={title}>
    <svg className={`icon ${iconClass} align-middle`}>
      <use href={`${iconSprite}#it-telephone`} />
    </svg>
    </span>
  );
};

export default PhoneIcon;